export function normalizeLicensePlate(value: string): string {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function isValidBrazilianLicensePlate(value: string): boolean {
  return /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(normalizeLicensePlate(value));
}

export function formatLicensePlateInput(value: string): string {
  const plate = normalizeLicensePlate(value).slice(0, 7);
  if (plate.length <= 3) return plate;
  return `${plate.slice(0, 3)}-${plate.slice(3)}`;
}
